module.exports = __webpack_public_path__ + "assets/units/sprites/Infernal - Scorched Ground.png";